import { useState, type FormEvent } from 'react'
import { ApiError, api } from '../api'

export default function Login({ onSuccess }: { onSuccess: () => void }) {
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await api.login(password)
      onSuccess()
    } catch (err) {
      if (err instanceof ApiError && err.status === 429) {
        setError(`Too many attempts. Try again in ${err.retryAfter ?? 60}s.`)
      } else {
        setError('That password is not right.')
      }
      setPassword('')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="login">
      <form onSubmit={submit}>
        <div>
          <h1>Mood Tracker</h1>
          <p>Enter your password to continue.</p>
        </div>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          autoComplete="current-password"
          autoFocus
          required
        />
        {error && <p className="error-text">{error}</p>}
        <button className="btn" type="submit" disabled={busy || !password}>
          {busy ? 'Checking…' : 'Sign in'}
        </button>
      </form>
    </div>
  )
}
